import React, { useState, useEffect } from "react";
import hover_matches_list from "../../../assets/svgs/hover_matches_list.svg";
import delete_icon from "../../../assets/svgs/delete_icon.svg";
import { tokenDetailsTableStyle as styles } from "./cartInfo.tailwind";
import { useSelector } from "react-redux";
import { Tooltip, ClickAwayListener } from "@mui/material";

const TokenDetailsTable = ({ tokenDetails, handleOpenModal }) => {
  const { alreadyPurchasedTokens, unavailableTokens } = useSelector((state) => state.cart);
  const isTokenUnavailable = (tokenId) => unavailableTokens?.includes(tokenId);
  const isTokenPurchased = (tokenId) => alreadyPurchasedTokens?.includes(tokenId);
  // State to control tooltip visibility for each tokenId
  const [openTooltips, setOpenTooltips] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  const handleTooltipOpen = (tokenId) => {
    setOpenTooltips((prev) => ({ ...prev, [tokenId]: true }));
  };

  const handleTooltipClose = (tokenId) => {
    setOpenTooltips((prev) => ({ ...prev, [tokenId]: false }));
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        {/* Table Headings */}
        <thead>
          <tr className="whitespace-nowrap b-bottom">
            <th className={styles.innerTableHead}>Token Name</th>
            <th className={styles.innerTableHead}>Zone</th>
            {/* <th className={styles.innerTableHead}>Purchase Type</th> */}
            <th className={styles.innerTableHead}>Price</th>
            <th className={styles.innerTableHead}>Action</th>
          </tr>
        </thead>
        
        {/* Table Body */}
        <tbody>
          {tokenDetails?.map((tokenDetail, index) => {
            const isUnavailable = isTokenUnavailable(tokenDetail.tokenId);
            const isPurchased = isTokenPurchased(tokenDetail.tokenId);
            const rowClass = isUnavailable || isPurchased ? "bg-[#ff3c0030]" : "";
            return (
              <tr
                key={tokenDetail.tokenId}
                className={`${rowClass} ${
                  index === tokenDetails?.length - 1 ? "" : styles.border
                } whitespace-nowrap`}
              >
                {/* Token Name */}
                <td className={styles.innerTableBody}>
                  <span>#{tokenDetail?.tokenName?.split('-')?.length > 0 ? tokenDetail?.tokenName?.split('-')[tokenDetail?.tokenName?.split('-')?.length - 1] : ""}</span>
                  {isPurchased && <span className="text-[#e31313e0]"> (Out of Stock)</span>}
                </td>
 
                {/* Zone Name */}
                <td className={styles.innerTableBody}>
                  <span>{tokenDetail?.zoneName}</span>
                </td>

                {/* Purchase Type */}
                {/* <td className={`${styles.innerTableBody} flex gap-2 items-center w-[100%]`}>
                  {tokenDetail?.purchaseType === "1"
                    ? "Entire Season"
                    : "Particular Games"} */}

                  {/* Display the hover icon if the purchase type is "Particular Games" */}
                  {/* {tokenDetail?.purchaseType !== "1" && (
                    <>
                      {isMobile ? (
                        <ClickAwayListener onClickAway={() => handleTooltipClose(tokenDetail?.tokenId)}>
                          <Tooltip
                            title={<ToolTipContent tokenDetail={tokenDetail} />}
                            className="w-[100%]"
                            arrow
                            open={!!openTooltips[tokenDetail?.tokenId]} // Ensure it's always a boolean
                          >
                            <img
                              src={hover_matches_list}
                              alt="hover_matches_list"
                              className={styles.hoverImage}
                              onClick={() => handleTooltipOpen(tokenDetail?.tokenId)}
                            />
                          </Tooltip>
                        </ClickAwayListener>
                      ) : (
                        <Tooltip
                          title={<ToolTipContent tokenDetail={tokenDetail} />}
                          className="w-[100%]"
                          arrow
                        >
                          <img
                            src={hover_matches_list}
                            alt="hover_matches_list"
                            className={styles.hoverImage}
                          />
                        </Tooltip>
                      )}
                    </>
                  )}
                </td> */}

                {/* Price */}
                <td className={styles.innerTableBody}>
                  {`$${tokenDetail?.adjustedTokenPrice}`}
                </td>

                {/* Action (Delete button) */}
                <td className={`${styles.innerTableBody}`}>
                  <button
                    className={styles.button}
                    onClick={() => handleOpenModal(tokenDetail.tokenId)}
                  >
                    <img src={delete_icon} alt="delete_icon" className={styles.deleteIcon} />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TokenDetailsTable;

const ToolTipContent = ({ tokenDetail }) => {
  return (
    <div className={styles.hoveredContainer}>
      <ul className="flex flex-col gap-2">
      {tokenDetail?.matchIds?.map((match, index) => (
          <li key={index} className={styles.hoverList}>
            {/* Display the awayTeamName */}
            <span>{match?.awayTeamName}</span>
            <img src={hover_matches_list} alt={match?.awayTeamName} />
          </li>
        ))}
      </ul>
    </div>
  )
}